/**
 * Created by dx.yang on 2017/2/22.
 */


export default {
    name: 'KsTableAdvHeader',
    props: {
        store: null,
    },
    methods: {
        filterClick(e, f, c) {
            c.show = false;
            this.store.commit('changeFilter', f);
        },
        showFilterList(c) {
            c.show = true;
        },
        hideFilterList(c) {
            c.show = false;
        },
        doSort(col) {
            let currentSort = this.store.states.currentSort;
            if (!currentSort.field) {
                currentSort.state = 'down';
            } else if (currentSort.field == col.field) {
                currentSort.state = {
                    down: 'up',
                    up: 'down'
                }[currentSort.state];
            }

            currentSort.field = col.field;
            currentSort.by = col.sort;
            this.store.commit('setSort');
        },
        checkAll() {
            this.store.commit('checkAll');
        }
    },
    render(h) {
        let states = this.store.states;
        let cols = states.columns;

        let ths = [];

        if (states.select.enabled) {
            let classes = 'ks-table-new-style-checkbox all-checked';
            if (states.checkedList.length != 0 && states.checkedList.length == states.rows2show.length) {
                classes += ' be-checked';
            }
            ths.push(
                <th>
                    <div class={classes}
                         on-click={ () => { this.checkAll() } }>
                        <div class="inner-checkbox">
                            <div class="inner-checkbox-dot"></div>
                        </div>
                    </div>
                </th>
            )
        }



        cols.forEach(c => {
            let thContent = [];
            if (c.sort) {
                let direct = 'fa fa-sort';
                let currentSort = states.currentSort;
                if (currentSort.field === c.field) {
                    switch (currentSort.state) {
                        case 'up':
                            direct = 'fa fa-sort-up';
                            break;
                        case 'down':
                            direct = 'fa fa-sort-down';
                            break;
                        default: break;
                    }
                }
                thContent.push(<span class="ks-th-sort-tip">
                    <i class={direct}></i>
                </span>)
            }

            let label = c.label;
            if (c.filter) {

                //let currentFilter = _.isEmpty(states.currentFilter) ? c.filter[0] : states.currentFilter;
                // console.log(states.currentFilter);
                // _.forEach(states.currentFilter, (item, field) => {
                //
                // });
                let currentFilter;
                for (let i = 0; i < c.filter.length; i++) {
                    let f = c.filter[i].field;
                    currentFilter = states.currentFilter[f];
                    if (!currentFilter) {
                        continue;
                    }
                }

                thContent.push(
                    <div class="th-filter-div"
                         on-mousemove={ ()=>{this.showFilterList(c)} }
                         on-mouseout={ ()=>{this.hideFilterList(c)} }>
                        <div class="ks-ctrl-collapse">
                            <div class="ks-ctrl-collapse-down"></div>
                        </div>
                        <ul class="ks-dropdown-menu" style={ c.show ? 'display:inline-block' : 'display:none' }>
                            {
                                c.filter.map(f => {
                                    return (
                                        <li class={ currentFilter.field == f.field && currentFilter.value == f.value ? 'active' : '' }>
                                            <a href="javascript:;" on-click={ ($event) => this.filterClick($event, f, c)}>{f.title}</a>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                );
                label += `(${currentFilter.title})`;
            }
            if (c.sort) {
                ths.push(
                    <th class='sort-th'
                        on-click={ () => this.doSort(c) }>
                        {label} {thContent.map(t => t)}
                    </th>
                )
            } else {
                ths.push(
                    <th>
                        {label} {thContent.map(t => t)}
                    </th>
                )
            }
        });

        return (
            <table class="ks-table">
                <colgroup>
                    {
                        states.select.enabled && <col width='25' />
                    }
                    {
                        cols.map(c => <col width={c.realWidth} />)
                    }
                    {
                        <col />
                    }
                </colgroup>
                <thead>
                <tr>
                    { ths.map(th => th) }
                </tr>
                </thead>
            </table>
        );
    }
}